<template>
<div class="chapter">
<div class="inner_page">
<h1 class="h1">CONTENTS</h1>
<nav epub:type="toc" id="toc">
<ol class="tocol">
<li class="table-of-content">
<a href="#/0_chapter101difficulttodistinguishbetweenfriendandfoe">CHAPTER 101 - DIFFICULT TO DISTINGUISH BETWEEN FRIEND AND FOE</a>
</li>
<li class="table-of-content">
<a href="#/1_chapter102heavenlythunderandearthfire">CHAPTER 102 - HEAVENLY THUNDER AND EARTH FIRE</a>
</li>
<li class="table-of-content">
<a href="#/2_chapter103mindyourownbusiness">CHAPTER 103 - MIND YOUR OWN BUSINESS</a>
</li>
<li class="table-of-content">
<a href="#/3_chapter104mysteriouspainting">CHAPTER 104 - MYSTERIOUS PAINTING</a>
</li>
<li class="table-of-content">
<a href="#/4_chapter105goodbyelittlewen">CHAPTER 105 - GOODBYE LITTLE WEN</a>
</li>
<li class="table-of-content">
<a href="#/5_chapter106seeoff">CHAPTER 106 - SEE OFF</a>
</li>
<li class="table-of-content">
<a href="#/6_chapter107greatmother">CHAPTER 107 - GREAT MOTHER</a>
</li>
<li class="table-of-content">
<a href="#/7_chapter108loveandhate">CHAPTER 108 - LOVE AND HATE</a>
</li>
<li class="table-of-content">
<span href="#/8_chapter109passingby" title="Link target outside of Sample">CHAPTER 109 - PASSING BY</span>
</li>
<li class="table-of-content">
<span href="#/9_chapter110seeyoulater" title="Link target outside of Sample">CHAPTER 110 - SEE YOU LATER</span>
</li>
<li class="table-of-content">
<span href="#/10_chapter111unrivaledgoodman" title="Link target outside of Sample">CHAPTER 111 - UNRIVALED GOOD MAN</span>
</li>
<li class="table-of-content">
<span href="#/11_chapter112therevengeofkillingthemother" title="Link target outside of Sample">CHAPTER 112 - THE REVENGE OF KILLING THE MOTHER</span>
</li>
<li class="table-of-content">
<span href="#/12_chapter113revenge" title="Link target outside of Sample">CHAPTER 113 - REVENGE</span>
</li>
<li class="table-of-content">
<span href="#/13_chapter114alarmeduncertainty" title="Link target outside of Sample">CHAPTER 114 - ALARMED UNCERTAINTY</span>
</li>
<li class="table-of-content">
<span href="#/14_chapter115toad" title="Link target outside of Sample">CHAPTER 115 - TOAD</span>
</li>
<li class="table-of-content">
<span href="#/15_chapter116lustturtle" title="Link target outside of Sample">CHAPTER 116 - LUST TURTLE</span>
</li>
<li class="table-of-content">
<span href="#/16_chapter117showbazaar" title="Link target outside of Sample">CHAPTER 117 - SHOWBAZAAR</span>
</li>
<li class="table-of-content">
<span href="#/17_chapter118jiangxue" title="Link target outside of Sample">CHAPTER 118 - JIANG XUE</span>
</li>
<li class="table-of-content">
<span href="#/18_chapter119threewomenforaplay" title="Link target outside of Sample">CHAPTER 119 - THREE WOMEN FOR A PLAY</span>
</li>
<li class="table-of-content">
<span href="#/19_chapter120difficulttoretract" title="Link target outside of Sample">CHAPTER 120 - DIFFICULT TO RETRACT</span>
</li>
<li class="table-of-content">
<span href="#/20_chapter121passion" title="Link target outside of Sample">CHAPTER 121 - PASSION</span>
</li>
<li class="table-of-content">
<span href="#/21_chapter122firstaid" title="Link target outside of Sample">CHAPTER 122 - FIRST AID</span>
</li>
<li class="table-of-content">
<span href="#/22_chapter123possession" title="Link target outside of Sample">CHAPTER 123 - POSSESSION</span>
</li>
<li class="table-of-content">
<span href="#/23_chapter124funeral" title="Link target outside of Sample">CHAPTER 124 - FUNERAL</span>
</li>
<li class="table-of-content">
<span href="#/24_chapter125painandhappiness" title="Link target outside of Sample">CHAPTER 125 - PAIN AND HAPPINESS</span>
</li>
<li class="table-of-content">
<span href="#/25_chapter126restaurant" title="Link target outside of Sample">CHAPTER 126 - RESTAURANT</span>
</li>
<li class="table-of-content">
<span href="#/26_chapter127flyinrestaurant" title="Link target outside of Sample">CHAPTER 127 - FLY IN RESTAURANT</span>
</li>
<li class="table-of-content">
<span href="#/27_chapter128fight" title="Link target outside of Sample">CHAPTER 128 - FIGHT</span>
</li>
<li class="table-of-content">
<span href="#/28_chapter129abdominalbackenemy" title="Link target outside of Sample">CHAPTER 129 - ABDOMINAL BACK ENEMY</span>
</li>
<li class="table-of-content">
<span href="#/29_chapter130chenwenappeared" title="Link target outside of Sample">CHAPTER 130 - CHEN WEN APPEARED</span>
</li>
<li class="table-of-content">
<span href="#/30_chapter131triplexstate" title="Link target outside of Sample">CHAPTER 131 - TRIPLEX STATE</span>
</li>
<li class="table-of-content">
<span href="#/31_chapter132chenwensawakening" title="Link target outside of Sample">CHAPTER 132 - CHEN WEN'S AWAKENING</span>
</li>
<li class="table-of-content">
<span href="#/32_chapter133cooldownskills" title="Link target outside of Sample">CHAPTER 133 - COOLDOWN SKILLS</span>
</li>
<li class="table-of-content">
<span href="#/33_chapter134ancientchinesemedicine" title="Link target outside of Sample">CHAPTER 134 - ANCIENT CHINESE MEDICINE</span>
</li>
<li class="table-of-content">
<span href="#/34_chapter135eccentricpatient" title="Link target outside of Sample">CHAPTER 135 - ECCENTRIC PATIENT</span>
</li>
<li class="table-of-content">
<span href="#/35_chapter136evil" title="Link target outside of Sample">CHAPTER 136 - EVIL</span>
</li>
<li class="table-of-content">
<span href="#/36_chapter137leftandright" title="Link target outside of Sample">CHAPTER 137 - LEFT AND RIGHT</span>
</li>
<li class="table-of-content">
<span href="#/37_chapter138chenwenforhelp" title="Link target outside of Sample">CHAPTER 138 - CHEN WEN FOR HELP</span>
</li>
<li class="table-of-content">
<span href="#/38_chapter139thedifficultiesofchenwen" title="Link target outside of Sample">CHAPTER 139 - THE DIFFICULTIES OF CHEN WEN</span>
</li>
<li class="table-of-content">
<span href="#/39_chapter140casinovisit" title="Link target outside of Sample">CHAPTER 140 - CASINO VISIT</span>
</li>
<li class="table-of-content">
<span href="#/40_chapter141alterationofxiaowen" title="Link target outside of Sample">CHAPTER 141 - ALTERATION OF XIAO WEN</span>
</li>
<li class="table-of-content">
<span href="#/41_chapter142thesmellofconspiracy" title="Link target outside of Sample">CHAPTER 142 - THE SMELL OF CONSPIRACY</span>
</li>
<li class="table-of-content">
<span href="#/42_chapter143scapegoat" title="Link target outside of Sample">CHAPTER 143 - SCAPEGOAT</span>
</li>
<li class="table-of-content">
<span href="#/43_chapter144poison" title="Link target outside of Sample">CHAPTER 144 - POISON</span>
</li>
<li class="table-of-content">
<span href="#/44_chapter145ethelsdisease" title="Link target outside of Sample">CHAPTER 145 - ETHEL'S DISEASE</span>
</li>
<li class="table-of-content">
<span href="#/45_chapter146infectiousdisease" title="Link target outside of Sample">CHAPTER 146 - INFECTIOUS DISEASE</span>
</li>
<li class="table-of-content">
<span href="#/46_chapter147iraqbattlefield" title="Link target outside of Sample">CHAPTER 147 - IRAQ BATTLEFIELD</span>
</li>
<li class="table-of-content">
<span href="#/47_chapter148loverival" title="Link target outside of Sample">CHAPTER 148 - LOVE RIVAL</span>
</li>
<li class="table-of-content">
<span href="#/48_chapter149wuqian" title="Link target outside of Sample">CHAPTER 149 - WU QIAN</span>
</li>
<li class="table-of-content">
<span href="#/49_chapter150pharmaceuticalcompany" title="Link target outside of Sample">CHAPTER 150 - PHARMACEUTICAL COMPANY</span>
</li>
<li class="table-of-content">
<span href="#/50_chapter151uninvitedguest" title="Link target outside of Sample">CHAPTER 151 - UNINVITED GUEST</span>
</li>
<li class="table-of-content">
<span href="#/51_chapter152combat" title="Link target outside of Sample">CHAPTER 152 - COMBAT</span>
</li>
<li class="table-of-content">
<span href="#/52_chapter153debilitatingforce" title="Link target outside of Sample">CHAPTER 153 - DEBILITATING FORCE</span>
</li>
<li class="table-of-content">
<span href="#/53_chapter154oldplace" title="Link target outside of Sample">CHAPTER 154 - OLD PLACE</span>
</li>
<li class="table-of-content">
<span href="#/54_chapter155extramaritallove" title="Link target outside of Sample">CHAPTER 155 - EXTRAMARITAL LOVE</span>
</li>
<li class="table-of-content">
<span href="#/55_chapter156undead" title="Link target outside of Sample">CHAPTER 156 - UNDEAD</span>
</li>
<li class="table-of-content">
<span href="#/56_chapter157mutualharm" title="Link target outside of Sample">CHAPTER 157 - MUTUAL HARM</span>
</li>
<li class="table-of-content">
<span href="#/57_chapter158oldevents" title="Link target outside of Sample">CHAPTER 158 - OLD EVENTS</span>
</li>
<li class="table-of-content">
<span href="#/58_chapter159charity" title="Link target outside of Sample">CHAPTER 159 - CHARITY</span>
</li>
<li class="table-of-content">
<span href="#/59_chapter160everyonehastheirownaspirations" title="Link target outside of Sample">CHAPTER 160 - EVERYONE HAS THEIR OWN ASPIRATIONS</span>
</li>
<li class="table-of-content">
<span href="#/60_chapter161creationofopportunities" title="Link target outside of Sample">CHAPTER 161 - CREATION OF OPPORTUNITIES</span>
</li>
<li class="table-of-content">
<span href="#/61_chapter162scientificcontrast" title="Link target outside of Sample">CHAPTER 162 - SCIENTIFIC CONTRAST</span>
</li>
<li class="table-of-content">
<span href="#/62_chapter163impersonation" title="Link target outside of Sample">CHAPTER 163 - IMPERSONATION</span>
</li>
<li class="table-of-content">
<span href="#/63_chapter164subscript" title="Link target outside of Sample">CHAPTER 164 - SUBSCRIPT</span>
</li>
<li class="table-of-content">
<span href="#/64_chapter165thetruth" title="Link target outside of Sample">CHAPTER 165 - THE TRUTH</span>
</li>
<li class="table-of-content">
<span href="#/65_chapter166firstreadingsecretbook" title="Link target outside of Sample">CHAPTER 166 - FIRST READING SECRET BOOK</span>
</li>
<li class="table-of-content">
<span href="#/66_chapter167jade" title="Link target outside of Sample">CHAPTER 167 - JADE</span>
</li>
<li class="table-of-content">
<span href="#/67_chapter168vinegar" title="Link target outside of Sample">CHAPTER 168 - VINEGAR</span>
</li>
<li class="table-of-content">
<span href="#/68_chapter169buyacar" title="Link target outside of Sample">CHAPTER 169 - BUY A CAR</span>
</li>
<li class="table-of-content">
<span href="#/69_chapter170lilyblooming" title="Link target outside of Sample">CHAPTER 170 - LILY BLOOMING</span>
</li>
<li class="table-of-content">
<span href="#/70_chapter171strangedreams" title="Link target outside of Sample">CHAPTER 171 - STRANGE DREAMS</span>
</li>
<li class="table-of-content">
<span href="#/71_chapter172strangepatient" title="Link target outside of Sample">CHAPTER 172 - STRANGE PATIENT</span>
</li>
<li class="table-of-content">
<span href="#/72_chapter173mysteriousmaster" title="Link target outside of Sample">CHAPTER 173 - MYSTERIOUS MASTER</span>
</li>
<li class="table-of-content">
<span href="#/73_chapter174wuyu" title="Link target outside of Sample">CHAPTER 174 - WU YU</span>
</li>
<li class="table-of-content">
<span href="#/74_chapter175sellinghouse" title="Link target outside of Sample">CHAPTER 175 - SELLING HOUSE</span>
</li>
<li class="table-of-content">
<span href="#/75_chapter176clearskythunderbolt" title="Link target outside of Sample">CHAPTER 176 - CLEAR SKY THUNDERBOLT</span>
</li>
<li class="table-of-content">
<span href="#/76_chapter177bigdays" title="Link target outside of Sample">CHAPTER 177 - BIG DAYS</span>
</li>
<li class="table-of-content">
<span href="#/77_chapter178helloelderbrotherandeldersisterinlaw" title="Link target outside of Sample">CHAPTER 178 - HELLO ELDER BROTHER AND ELDER SISTER-IN-LAW</span>
</li>
<li class="table-of-content">
<span href="#/78_chapter179twothingstosay" title="Link target outside of Sample">CHAPTER 179 - TWO THINGS TO SAY</span>
</li>
<li class="table-of-content">
<span href="#/79_chapter180thewoundedlidesheng" title="Link target outside of Sample">CHAPTER 180 - THE WOUNDED LI DESHENG</span>
</li>
<li class="table-of-content">
<span href="#/80_chapter181breakanarmwithoutaword" title="Link target outside of Sample">CHAPTER 181 - BREAK AN ARM WITHOUT A WORD</span>
</li>
<li class="table-of-content">
<span href="#/81_chapter182legendofthejadegang" title="Link target outside of Sample">CHAPTER 182 - LEGEND OF THE JADE GANG</span>
</li>
<li class="table-of-content">
<span href="#/82_chapter183thetruthaboutwuyu" title="Link target outside of Sample">CHAPTER 183 - THE TRUTH ABOUT WU YU</span>
</li>
<li class="table-of-content">
<span href="#/83_chapter184expandsite" title="Link target outside of Sample">CHAPTER 184 - EXPAND SITE</span>
</li>
<li class="table-of-content">
<span href="#/84_chapter185royalno1" title="Link target outside of Sample">CHAPTER 185 - ROYAL NO1</span>
</li>
<li class="table-of-content">
<span href="#/85_chapter186acompletevictory" title="Link target outside of Sample">CHAPTER 186 - A COMPLETE VICTORY</span>
</li>
<li class="table-of-content">
<span href="#/86_chapter187greatsleep" title="Link target outside of Sample">CHAPTER 187 - GREAT SLEEP</span>
</li>
<li class="table-of-content">
<span href="#/87_chapter188greenringcompany" title="Link target outside of Sample">CHAPTER 188 - GREEN RING COMPANY</span>
</li>
<li class="table-of-content">
<span href="#/88_chapter189spacermigration" title="Link target outside of Sample">CHAPTER 189 - SPACER MIGRATION</span>
</li>
<li class="table-of-content">
<span href="#/89_chapter190longroad" title="Link target outside of Sample">CHAPTER 190 - LONG ROAD</span>
</li>
<li class="table-of-content">
<span href="#/90_chapter191entanglement" title="Link target outside of Sample">CHAPTER 191 - ENTANGLEMENT</span>
</li>
<li class="table-of-content">
<span href="#/91_chapter192ifoneroomwasnotswepthowcouldonesweeptheworld" title="Link target outside of Sample">CHAPTER 192 - IF ONE ROOM WAS NOT SWEPT HOW COULD ONE SWEEP THE WORLD</span>
</li>
<li class="table-of-content">
<span href="#/92_chapter193liulei" title="Link target outside of Sample">CHAPTER 193 - LIU LEI</span>
</li>
<li class="table-of-content">
<span href="#/93_chapter194lookingfortrouble" title="Link target outside of Sample">CHAPTER 194 - LOOKING FOR TROUBLE</span>
</li>
<li class="table-of-content">
<span href="#/94_chapter195herosavebeauty" title="Link target outside of Sample">CHAPTER 195 - HERO SAVE BEAUTY</span>
</li>
<li class="table-of-content">
<span href="#/95_chapter196witchcraft" title="Link target outside of Sample">CHAPTER 196 - WITCHCRAFT</span>
</li>
<li class="table-of-content">
<span href="#/96_chapter197asyouwish" title="Link target outside of Sample">CHAPTER 197 - AS YOU WISH</span>
</li>
<li class="table-of-content">
<span href="#/97_chapter198strangedisorder" title="Link target outside of Sample">CHAPTER 198 - STRANGE DISORDER</span>
</li>
<li class="table-of-content">
<span href="#/98_chapter199farawayhome" title="Link target outside of Sample">CHAPTER 199 - FARAWAY HOME</span>
</li>
<li class="table-of-content">
<span href="#/99_chapter200survey" title="Link target outside of Sample">CHAPTER 200 - SURVEY</span>
</li>
</ol>
</nav>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// toc.vue?77f9ffa3